import { render, staticRenderFns } from "./spiritualLabor.vue?vue&type=template&id=6d7345de&scoped=true&"
import script from "./spiritualLabor.vue?vue&type=script&lang=js&"
export * from "./spiritualLabor.vue?vue&type=script&lang=js&"
import style0 from "./spiritualLabor.vue?vue&type=style&index=0&id=6d7345de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7345de",
  null
  
)

export default component.exports